import Auth from 'j-toker';
import { browserHistory } from 'react-router';
import store from 'store';
import * as authentication from 'actions/authenticationActions';
import { authorizedRoute } from 'helpers/permissionsHelper';
import { isSelfService, isAuthenticating, isSelfServiceRoute } from 'helpers/Authentication/index';
import { routes, dashboardForAgent } from 'helpers/RouterHelper';
import logoutUser from './logoutUser';

export default function authenticateLandlord(nextState, replace, callback) {
  if (isAuthenticating()) {
    return;
  }

  if (!Auth.user || !Auth.user.first_name || !Auth.user.type) {
    return;
  }

  if (Auth.user.type !== 'agent') {
    logoutUser();
    callback();
    return;
  }

  const currentLocation = browserHistory.getCurrentLocation();

  // IMPORTANT: Security: added check to make sure self service users only go to allowed pages.
  if (
    isSelfService(Auth.user.permission) &&
    !isSelfServiceRoute(currentLocation.pathname, Auth.user.permission)
  ) {
    logoutUser();
    callback();
    return;
  }

  window.gtag('config', 'GA_MEASUREMENT_ID', {
    page_path: currentLocation.pathname,
  });

  // eslint-disable-next-line
  localStorage.setItem('currentConfigName', '"landlord"');
  store.dispatch(authentication.logUserIn());
  if (
    currentLocation.pathname.startsWith(routes.dashboard) &&
    dashboardForAgent(Auth.user.permission) !== routes.dashboard
  ) {
    browserHistory.push(dashboardForAgent(Auth.user.permission) + currentLocation.search);
  }

  if (!authorizedRoute(currentLocation.pathname, Auth.user.permission)) {
    browserHistory.push(dashboardForAgent(Auth.user.permission) + currentLocation.search);
  }

  if (currentLocation.pathname === '/companies/internal_document_portal') {
    store.dispatch(authentication.showSignaturePage());
  }

  callback();
  return;
}
